var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.baseCrudKey === 'miscTransaction')?_c('MiscExpandableRow',{attrs:{"item":_vm.item}}):_c('span',[_vm._v("(Write a custom expandable row as per need.)")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }